export default __webpack_public_path__ + "static/media/bag.67b04b4c.svg";